import {
    ChangeEvent, ChangeEventHandler, FormEventHandler, useState
} from 'react';
import { useDispatch } from 'react-redux';

import {
    AppURLSearchParams, Credentials, fetchPostSessionsRequest
} from '../../../auth';
import { useQueryParams } from '@hooks';
import { isDefined } from '@utils';

type LoginFormState = Partial<Credentials> & { env?: string };

export type CredentialParamsDictionary = {
    [AppURLSearchParams.env]?: string
    [AppURLSearchParams.username]?: string
    [AppURLSearchParams.password]?: string
};

export const useTestLogin = () => {
    const {
        username, password, env
    } = useQueryParams<CredentialParamsDictionary>();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState<LoginFormState>({
        ...username && { username },
        ...password && { password },
        env: env || 'qa'
    });
    const dispatch = useDispatch<any>();
    const handleLoginResponse = async () => {
        setIsLoading(false);
    };
    const handleLoginError = (error: any) => {
        alert(error?.message);
        console.error(error?.message);

        setIsLoading(false);
    };
    const handleSubmit: FormEventHandler = (event) => {
        event.preventDefault();

        if (isValidCredentials(state)) {
            dispatch(fetchPostSessionsRequest({
                userName: state.username,
                password: state.password,
                env: state.env
            })).then(handleLoginResponse, handleLoginError);

            setIsLoading(true);
        } else {
            alert('login form incomplete');

            return;
        }
    };
    const handleChange: ChangeEventHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state || {},
            [event.target.id]: event.target.value
        });
    };

    return {
        onSubmit: handleSubmit,
        onBlur: handleChange,
        isLoading,
        state
    };
};

function isValidCredentials (value: any): value is Required<LoginFormState> {
    return (
        isDefined(value?.username) &&
        isDefined(value?.password) &&
        isDefined(value?.env)
    );
}
